<template>
  <ion-modal
    class="modal-center"
    :ref="props.modalRef"
    :trigger="props.modalTrigger"
    backdrop-dismiss="false"
  >
    <ion-card class="bg-white m-0 p-0 rounded-xl">
      <ion-card-content class="p-4">
        <ion-grid>
          <ion-row>
            <ion-col class="py-0">
              <ion-icon
                src="/assets/general/close-grey.svg"
                class="w-[24px] h-[24px] absolute block right-0 m-1 cursor-pointer opacity-80 hover:opacity-100"
                @click="closeModal"
              ></ion-icon>
              <ion-text class="ion-text-purple block my-2 mr-8">
                <slot></slot>
              </ion-text>
              <button
                expand="block"
                color="secondary"
                class="button-purple button-icon button-icon-phone my-3"
              >
                <a :href="'tel:' + configPhone">
                  <span
                    class="block capitalize text-white text-[14px] font-semibold height-[60px] text-left pl-14"
                  >
                    Call Customer Service
                    <small class="block">{{ configPhone }}</small>
                  </span>
                </a>
              </button>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-card-content>
    </ion-card>
  </ion-modal>
</template>

<script setup>
import { computed } from "vue";
import { useConfigStore } from "@/stores";
import { storeToRefs } from "pinia";
import { modalController } from "@ionic/vue";
const props = defineProps(['modalRef', 'modalTrigger']);
const configStore = useConfigStore();
const { config, defaultPhone } = storeToRefs(configStore);
const configPhone = computed(() =>
  config.customer_service_phone
    ? config.customer_service_phone
    : defaultPhone.value
);
const closeModal = () => {
  modalController.dismiss();
};
</script>
